import { BaseNumber, CheckedAddress, NormalizedNumber } from '@sparkdotfi/common-universal'
import { QueryKey, queryOptions } from '@tanstack/react-query'
import { Config } from 'wagmi'
import { readContract } from 'wagmi/actions'

import { spkStakingModuleAbi, spkStakingModuleAddress } from '@/config/contracts-generated'
import { getContractAddress } from '@/domain/hooks/useContractAddress'
import { Token } from '@/domain/types/Token'

export interface SpkStakeAmountQueryOptionsParams {
  address: CheckedAddress | undefined
  chainId: number
  wagmiConfig: Config
  spk: Token
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function spkStakeAmountQueryOptions({ address, chainId, wagmiConfig, spk }: SpkStakeAmountQueryOptionsParams) {
  return queryOptions({
    queryKey: spkStakeAmountQueryKey({ address, chainId }),
    queryFn: () => spkStakeAmountQueryFunction({ address, chainId, wagmiConfig, spk }),
  })
}

export function spkStakeAmountQueryKey({
  address,
  chainId,
}: Pick<SpkStakeAmountQueryOptionsParams, 'address' | 'chainId'>): QueryKey {
  return ['spk-airdrop-stake', address, chainId]
}

export async function spkStakeAmountQueryFunction({
  address,
  wagmiConfig,
  chainId,
  spk,
}: SpkStakeAmountQueryOptionsParams): Promise<NormalizedNumber> {
  if (!address) {
    return NormalizedNumber(0)
  }

  const result = await readContract(wagmiConfig, {
    address: getContractAddress(spkStakingModuleAddress, chainId),
    abi: spkStakingModuleAbi,
    functionName: 'activeSharesOf',
    args: [address],
    chainId,
  })

  return BaseNumber(result).toNormalizedUnit(spk.decimals)
}
